const Products = {
    text: 'My Products',
    link: '/products',
    icon: 'fa fa-gift'
};

const Profile = {
    text: 'Employee<br>Profile',
    link: '/my-account/profile',
    icon: 'fa fa-user'
};
const Order_Requests = {
    text: 'Order<br>Requests',
    link: '/my-account/order-history',
    icon: 'fa fa-clipboard'
};
const Inbox = {
    text: 'My Inbox',
    link: '/my-account/inbox',
    icon: 'fa fa-envelope-o',
    append_count: 'my_inbox'
};
const Pending_Requests = {
    text: 'Pending<br>Requests',
    link: '/my-account/pending-requests',
    icon: 'icon-hourglass',
    append_count: 'pending_requests'
};
const Orders = {
    text: 'Orders',
    link: '/my-account/orders',
    icon: 'fa fa-ticket',
    append_count: 'orders'
};
/*const MyAccount = {
    text: 'My Account',
    link: '/my-account',
    icon: 'icon-user',
    submenu: [
        {
            text: 'Employee Profile',
            link: '/my-account/profile'
        },
        {
            text: 'Order Requests',
            link: '/my-account/order-history'
        },
        {
            text: 'My Inbox',
            link: '/my-account/inbox',
            append_count: 'my_inbox'
        },
        {
            text: 'Pending Requests',
            link: '/my-account/pending-requests',
            append_count: 'pending_requests'
        },
        {
            text: 'Orders',
            link: '/my-account/orders',
            append_count: 'orders'
        }
    ]
};*/

const headingMain = {
    text: 'Main Navigation',
    heading: true
};

export const menu = [
    headingMain,
    Products,
    Profile,
    Order_Requests,
    Inbox,
    Pending_Requests,
    Orders
     // MyAccount
];



// WEBPACK FOOTER //
// /opt/build/repo/src/app/routes/menu.ts